import axios from 'axios';

export const useFetchContactDetails = async (language: string, title: string): Promise<any> => {
    const data = await axios.post(
        `${process.env.DRUPAL_URL}/graphql`,
        {
            query: `query fetchContactDetails($language: String!, $title: String!) {
                        page(language: $language, title: $title) {
                            body
                        }
                    }
            `,
            variables: {
                language: language,
                title: title,
            },
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return data?.data?.data?.page?.body ?? '';
};
